<script setup lang="ts">
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui'
import type { TooltipContentProps } from 'reka-ui'

defineOptions({ inheritAttrs: false })

interface Props {
  text?: string
  side?: TooltipContentProps['side']
  align?: TooltipContentProps['align']
  sideOffset?: number
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  side: 'top',
  align: 'center',
  sideOffset: 4,
  disabled: false
})
</script>

<template>
  <template v-if="props.disabled">
    <slot v-bind="$attrs" />
  </template>
  <Tooltip v-else v-bind="$attrs">
    <TooltipTrigger as-child>
      <slot />
    </TooltipTrigger>
    <TooltipContent :side="props.side" :align="props.align" :side-offset="props.sideOffset">
      <slot name="content">
        {{ props.text }}
      </slot>
    </TooltipContent>
  </Tooltip>
</template>
